import {
  IonButton,
  IonButtons,
  IonContent,
  IonFab,
  IonFabButton,
  IonFooter,
  IonHeader,
  IonIcon,
  IonInput,
  IonItem,
  IonItemDivider,
  IonItemGroup,
  IonLabel,
  IonSkeletonText,
  IonModal,
  IonSelect,
  IonSelectOption,
  IonTitle,
  IonToolbar,
  useIonToast,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardSubtitle,
} from "@ionic/react";
import { add, arrowForwardCircleOutline } from "ionicons/icons";
import React, { useState } from "react";
import { useCollection } from "react-firebase-hooks/firestore";
import { useFirebase } from "../firebase-provider";
import PageLayout from "../layout";

const CashBank: React.FC = () => {
  const [toast] = useIonToast();
  const { firestore } = useFirebase();
  const [modal, setModal] = useState({ add: false, transfer: false });
  const [isSubmitting, setSubmitting] = useState(false);
  const [addData, setAddData] = useState({
    jenis: "cash",
    bank: "",
    nama: "",
    nomor: "",
    saldo: 0,
  });

  const [snapshots, loading] = useCollection(
    firestore.collection("/data/keuangan/akun")
  );

  const initTransferModalData = {
    id: "",
    jenis: "cash",
    bank: "",
    nama: "",
    nomor: "",
    saldo: 0,
    transferTujuan: "",
    transferJumlah: 0,
  };
  const [transferModalData, setTransferModalData] = useState(
    initTransferModalData
  );

  const handleAddDataChange = (el: any) =>
    setAddData({ ...addData, [el.target.name]: el.detail.value });

  const validasiData = () => {
    if (addData.bank === "" && addData.jenis !== ("cash" || "other")) {
      toast({
        message: "Nama Bank/E-Wallet tidak boleh kosong!",
        duration: 3000,
        color: "danger",
        position: "top",
      });
    } else if (addData.nama === "") {
      toast({
        message: "Nama akun tidak boleh kosong!",
        duration: 3000,
        color: "danger",
        position: "top",
      });
    } else if (addData.nomor === "" && addData.jenis !== ("cash" || "other")) {
      toast({
        message: "Nomor akun tidak boleh kosong!",
        duration: 3000,
        color: "danger",
        position: "top",
      });
    } else return true;
  };
  return (
    <PageLayout title="Kas &amp; Bank">
      <IonCard mode="ios">
        <IonCardHeader>
          <IonCardSubtitle>Dana Tapak Industries</IonCardSubtitle>
          <IonCardTitle color="success">
            {new Intl.NumberFormat("id-ID", {
              style: "currency",
              currency: "IDR",
              maximumSignificantDigits: 10,
            }).format(
              Number(
                snapshots?.docs
                  ?.map((doc: any) => Number(doc.data()?.saldo || 0))
                  .reduce((a, b) => a + b, 0)
              ) || 0
            )}
          </IonCardTitle>
        </IonCardHeader>
      </IonCard>
      <IonItemGroup>
        {loading &&
          Array.from({ length: 5 }).map((el, i) => (
            <React.Fragment key={i}>
              <IonItem button detail lines="full">
                <IonLabel>
                  <IonSkeletonText animated style={{ width: "10em" }} />
                  <p>
                    <IonSkeletonText animated style={{ width: "7em" }} />
                  </p>
                </IonLabel>
                <IonLabel slot="end" className="ion-text-end" color="success">
                  <IonSkeletonText animated style={{ width: "4em" }} />
                </IonLabel>
              </IonItem>
            </React.Fragment>
          ))}
        {!loading &&
          snapshots &&
          snapshots?.docs?.map((doc: any) => {
            const data = doc.data();
            return (
              <React.Fragment key={doc.id}>
                <IonItem
                  button
                  detail
                  lines="full"
                  onClick={() => {
                    setModal({ ...modal, transfer: true });
                    setTransferModalData({
                      id: doc.id,
                      transferTujuan: "",
                      transferJumlah: 0,
                      ...data,
                    });
                  }}
                >
                  <IonLabel>
                    {data?.jenis === "cash"
                      ? `Kas ${data.nama}`
                      : `${data.bank} (${data.nama})`}
                    {data?.jenis !== "cash" && <p>{data.nomor}</p>}
                  </IonLabel>
                  <IonLabel slot="end" className="ion-text-end" color="success">
                    {new Intl.NumberFormat("id-ID", {
                      style: "currency",
                      currency: "IDR",
                      maximumSignificantDigits: 10,
                    }).format(Number(data.saldo || 0))}
                  </IonLabel>
                </IonItem>
              </React.Fragment>
            );
          })}
      </IonItemGroup>

      {/* MODAL ADD */}

      <IonModal
        isOpen={modal.add}
        onDidDismiss={() => setModal({ ...modal, add: false })}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Tambah Akun</IonTitle>
            <IonButtons slot="end">
              <IonButton onClick={() => setModal({ ...modal, add: false })}>
                Tutup
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonItemGroup>
            <IonItem>
              <IonLabel position="stacked">Jenis Akun</IonLabel>
              <IonSelect
                name="jenis"
                value={addData.jenis}
                onIonChange={handleAddDataChange}
                disabled={isSubmitting}
              >
                <IonSelectOption value="cash">Kas</IonSelectOption>
                <IonSelectOption value="bank">Bank</IonSelectOption>
                <IonSelectOption value="e-wallet">E-Wallet</IonSelectOption>
              </IonSelect>
            </IonItem>

            {(addData.jenis === "bank" || addData.jenis === "e-wallet") && (
              <IonItem>
                <IonLabel position="stacked">
                  {addData.jenis === "bank" ? "Nama Bank" : "Nama e-Wallet"}
                </IonLabel>
                <IonInput
                  name="bank"
                  placeholder={addData.jenis === "bank" ? "BANK BRI" : "DANA"}
                  value={addData.bank}
                  onIonChange={handleAddDataChange}
                  disabled={isSubmitting}
                />
              </IonItem>
            )}

            <IonItem>
              <IonLabel position="stacked">Nama Pemilik Akun</IonLabel>
              <IonInput
                name="nama"
                value={addData.nama}
                onIonChange={handleAddDataChange}
                disabled={isSubmitting}
              />
            </IonItem>

            {addData.jenis !== "cash" && (
              <IonItem>
                <IonLabel position="stacked">Nomor Akun</IonLabel>
                <IonInput
                  name="nomor"
                  value={addData.nomor}
                  onIonChange={handleAddDataChange}
                  disabled={isSubmitting}
                />
              </IonItem>
            )}

            <IonItem>
              <IonLabel position="stacked">Saldo Awal</IonLabel>
              <IonInput
                name="saldo"
                type="number"
                value={addData.saldo}
                onIonChange={(e) =>
                  setAddData({ ...addData, saldo: Number(e.detail.value) })
                }
                disabled={isSubmitting}
              />
            </IonItem>
          </IonItemGroup>
        </IonContent>
        <IonFooter>
          <IonToolbar>
            <IonButtons slot="end">
              <IonButton
                disabled={isSubmitting}
                onClick={async () => {
                  setSubmitting(true);
                  if (validasiData()) {
                    await firestore
                      .collection("/data/keuangan/akun")
                      .add(addData)
                      .then(() => {
                        setModal({ ...modal, add: false });
                        toast({
                          message: "Akun berhasil ditambahkan!",
                          duration: 3000,
                          color: "success",
                          position: "top",
                        });
                      })
                      .catch(() => {
                        toast({
                          message: "Terjadi kesalahan jaringan!",
                          duration: 3000,
                          color: "danger",
                          position: "top",
                        });
                      });
                  }
                  setSubmitting(false);
                }}
              >
                {!isSubmitting ? "Tambah" : "Membuat Akun. . ."}
              </IonButton>
              <IonButton
                color="danger"
                onClick={() => setModal({ ...modal, add: false })}
              >
                Batal
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonFooter>
      </IonModal>

      {/* MODAL TRANSFER */}

      <IonModal
        isOpen={modal.transfer}
        onDidDismiss={() => setModal({ ...modal, transfer: false })}
      >
        <IonHeader>
          <IonToolbar>
            <IonTitle>Detail Akun &amp; Transfer</IonTitle>
            <IonButtons slot="end">
              <IonButton
                onClick={() => setModal({ ...modal, transfer: false })}
              >
                Tutup
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonHeader>
        <IonContent>
          <IonItemGroup>
            <IonItemDivider>Informasi Akun</IonItemDivider>

            <IonItem lines="full">
              <IonLabel>
                <p>Pemilik Akun</p>
                {transferModalData?.nama}
              </IonLabel>
            </IonItem>

            <IonItem lines="full">
              <IonLabel>
                <p>Jenis</p>
                {transferModalData?.jenis}
              </IonLabel>
            </IonItem>

            {transferModalData?.jenis !== "cash" && (
              <IonItem lines="full">
                <IonLabel>
                  <p>
                    {transferModalData?.jenis === "bank"
                      ? "Nama Bank"
                      : "Nama e-Wallet"}
                  </p>
                  {transferModalData?.bank}
                </IonLabel>
              </IonItem>
            )}

            {transferModalData?.jenis !== "cash" && (
              <IonItem lines="full">
                <IonLabel>
                  <p>Nomor Akun e-Wallet / Rekening Bank</p>
                  {transferModalData?.nomor}
                </IonLabel>
              </IonItem>
            )}

            <IonItem lines="full">
              <IonLabel>
                <p>Saldo</p>
                {new Intl.NumberFormat("id-ID", {
                  style: "currency",
                  currency: "IDR",
                  maximumSignificantDigits: 10,
                }).format(Number(transferModalData?.saldo || 0))}
              </IonLabel>
            </IonItem>
            <IonItemDivider color="medium">Transfer</IonItemDivider>
            <IonItem lines="full" color="light">
              <IonLabel position="stacked">Rekening Tujuan</IonLabel>
              <IonSelect
                disabled={isSubmitting}
                value={transferModalData.transferTujuan}
                onIonChange={(el) =>
                  setTransferModalData({
                    ...transferModalData,
                    transferTujuan: el.detail.value,
                  })
                }
              >
                {snapshots?.docs
                  ?.filter((e: any) => e.id !== transferModalData.id)
                  ?.map((doc) => (
                    <React.Fragment key={doc.id}>
                      <IonSelectOption value={doc.id}>
                        {doc?.data()?.jenis === "cash"
                          ? `Kas ${doc?.data()?.nama}`
                          : `${doc?.data()?.bank} (${doc?.data()?.nama})`}
                      </IonSelectOption>
                    </React.Fragment>
                  ))}
              </IonSelect>
            </IonItem>
            <IonItem lines="full" color="light">
              <IonLabel position="stacked">Jumlah</IonLabel>
              <IonInput
                disabled={isSubmitting}
                value={transferModalData.transferJumlah}
                type="number"
                onIonChange={(el) =>
                  setTransferModalData({
                    ...transferModalData,
                    transferJumlah: Number(el.detail.value),
                  })
                }
              />
            </IonItem>
          </IonItemGroup>
        </IonContent>
        <IonFooter>
          <IonToolbar>
            <IonButtons slot="end">
              <IonButton
                disabled={
                  isSubmitting ||
                  transferModalData.transferJumlah <= 0 ||
                  transferModalData.transferTujuan === ""
                }
                onClick={async () => {
                  setSubmitting(true);
                  var kasAkunObj = Object.fromEntries(
                    new Map(snapshots?.docs?.map((doc) => [doc.id, doc.data()]))
                  );
                  let saldo_tujuan =
                    kasAkunObj[transferModalData.transferTujuan]?.saldo;
                  let saldo_sumber = transferModalData.saldo;

                  const updateTujuan = firestore
                    .collection("/data/keuangan/akun")
                    .doc(transferModalData.transferTujuan)
                    .update({
                      saldo:
                        Number(saldo_tujuan) +
                        Number(transferModalData.transferJumlah),
                    });

                  const updateSumber = firestore
                    .collection("/data/keuangan/akun")
                    .doc(transferModalData.id)
                    .update({
                      saldo:
                        Number(saldo_sumber) -
                        Number(transferModalData.transferJumlah),
                    });

                  await Promise.all([updateTujuan, updateSumber])
                    .then(() => {
                      setModal({ ...modal, add: false });
                      toast({
                        message: "Transfer Berhasil!",
                        duration: 3000,
                        color: "success",
                        position: "top",
                      });
                      setModal({ ...modal, transfer: false });
                      setTransferModalData(initTransferModalData);
                    })
                    .catch(() => {
                      toast({
                        message: "Transfer Gagal! Terjadi kesalahan jaringan!",
                        duration: 3000,
                        color: "danger",
                        position: "top",
                      });
                    });
                  setSubmitting(false);
                }}
              >
                {!isSubmitting ? "Transfer " : "Mentransfer Dana. . ."}
                <IonIcon icon={arrowForwardCircleOutline} />
              </IonButton>
            </IonButtons>
          </IonToolbar>
        </IonFooter>
      </IonModal>

      <IonFab slot="fixed" vertical="bottom" horizontal="end">
        <IonFabButton
          color="secondary"
          onClick={() => setModal({ ...modal, add: true })}
        >
          <IonIcon icon={add} />
        </IonFabButton>
      </IonFab>
    </PageLayout>
  );
};

export default CashBank;
